import { Inject } from '@angular/core';
import { ChangeDetectionStrategy, Component } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

type DialogData = {
  content: string;
}

@Component({
  selector: 'app-view-notification-dialog',
  templateUrl: './view-notification-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewNotificationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ViewNotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }
}

